import React, { useEffect, useState } from 'react'
import { toast, ToastContainer } from "react-toastify";

import "common/css/master.css";
import { getPrinciSignSvc, getLogoSvc, bonafideDtlsSvc } from './bonafideSvc';
import BonafidePdfAndroid from '../pdf/bonafidePdfAndroid ';

const BonafidePdfSliderAndroid = (props) => {
    const { certificateId } = props;

    const [pdfLoader, setPdfLoader] = useState("none");
    const [pdfOpacity, setPdfOpacity] = useState(1);
    const [schoolLogo, setSchoolLogo] = useState("");
    const [principalSign, setPrincipalSign] = useState("");
    const [pdfDtls, setPdfDtls] = useState({});

    useEffect(() => {
        // console.log("BonafidePdfSliderAndroid called, certificateId", certificateId);
        getPrinciSignSvc(cbPrinciSign);
        getLogoSvc(cbLogoResponse);
        getBonafideDtls(certificateId);

    }, [certificateId]);


    function cbLogoResponse(imageUrl) {
        // console.log("cbLogoResponse called, imageUrl", imageUrl);
        setSchoolLogo(imageUrl)
    }

    function cbPrinciSign(imageUrl) {
        setPrincipalSign(imageUrl);
    }

    const getBonafideDtls = (pCertificateId) => {
        // console.log("getBonafideDtls called");
        setPdfLoader("block");
        setPdfOpacity(0.5);
        bonafideDtlsSvc(pCertificateId, bonafideDtlsResponse);
    }

    const bonafideDtlsResponse = (data) => {
        // console.log("bonafideDtlsResponse called, data", data);
        if (data.status === "Success") {
            // console.log("data.certificateDtls in bonafideDtlsResponse", data.certificateDtls);
            setPdfDtls(data.certificateDtls);
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setPdfLoader("none");
        setPdfOpacity(1);
    }

    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg);
        }
    };

    return (
        <div >
                <BonafidePdfAndroid
                    schoolLogo={schoolLogo}
                    principalSign={principalSign}
                    pdfDtls={pdfDtls}
                />
        </div>
    );

}

export default BonafidePdfSliderAndroid;